import React from 'react';
import type { BombiixIconProps } from './types';

/**
 * Bombiix Table-view icon — 2x2 grid glyph.
 * Uses `currentColor` so the parent `.bombiix-icon-container` modifier drives the tint.
 */
const TableViewIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <path
      d="M15.5 8.5H8.5V15.5H14.667C14.8879 15.4999 15.0997 15.4121 15.2559 15.2559C15.4121 15.0997 15.4999 14.8879 15.5 14.667V8.5ZM4.5 14.667C4.50009 14.8879 4.58794 15.0997 4.74414 15.2559C4.90034 15.4121 5.11211 15.4999 5.33301 15.5H7.5V8.5H4.5V14.667ZM15.5 5.33301C15.4999 5.11211 15.4121 4.90034 15.2559 4.74414C15.0997 4.58794 14.8879 4.50009 14.667 4.5H8.5V7.5H15.5V5.33301ZM4.5 7.5H7.5V4.5H5.33301C5.11211 4.50009 4.90034 4.58794 4.74414 4.74414C4.58794 4.90034 4.50009 5.11211 4.5 5.33301V7.5ZM16.5 14.667C16.4999 15.1531 16.3066 15.6192 15.9629 15.9629C15.6192 16.3066 15.1531 16.4999 14.667 16.5H5.33301C4.84689 16.4999 4.38085 16.3066 4.03711 15.9629C3.69337 15.6192 3.50009 15.1531 3.5 14.667V5.33301C3.50009 4.84689 3.69337 4.38085 4.03711 4.03711C4.38085 3.69337 4.84689 3.50009 5.33301 3.5H14.667C15.1531 3.50009 15.6192 3.69337 15.9629 4.03711C16.3066 4.38085 16.4999 4.84689 16.5 5.33301V14.667Z"
      fill="currentColor"
    />
  </svg>
);

export default TableViewIcon;
